module.exports = __webpack_public_path__ + "media/images/the-information-pro-logo-light-6854bacb.svg";